var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"ok-only":"","id":"calendly-modal"}},[_c('vue-calendly',{attrs:{"url":"https://calendly.com/ppcmitchell/consultation-call?primary_color=ffa812","height":600}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }